var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"card-title text-center"},[_vm._v("Activation")]),_c('p',{staticClass:"card-text"},[_vm._v("Please wait a seconds.")]),_c('div',{staticClass:"text-center"},[_c('loading-container',{attrs:{"loading":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }